var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { autorun } from "mobx";
import { Retriever } from "../../../../common";
import { SportModel } from "../..";
export class AllSportsRetriever extends Retriever {
    constructor(dict) {
        super();
        this.allSportsItemId = "all";
        this.dict = dict;
        this.subscription = () => { };
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscription = autorun(() => {
                this.calcAllSports(state);
            });
        });
    }
    calcAllSports(state) {
        const count = this.getAllSportsCount(state);
        if (state.getItemById(this.allSportsItemId)) {
            state.update(this.allSportsItemId, { numberOfEvents: count });
        }
        else {
            state.add(this.getAllSportsItem(count));
        }
    }
    getAllSportsItem(count) {
        return new SportModel({
            id: "all",
            name: this.dict.allSports,
            numberOfEvents: count,
            order: -2
        }, "allSports");
    }
    getAllSportsCount(state) {
        return state.Items.filter(x => x.type === "sports").reduce((y, x) => y + x.numberOfEvents, 0);
    }
    deactivate() {
        this.subscription();
    }
}
//# sourceMappingURL=AllSportsRetriever.js.map